import { apiFetch } from '../lib/api';

export type SyncStatus = 'written' | 'unchanged' | 'skipped_no_shopify_id' | 'error';

export interface SyncResult {
  wheel_product_id: number;
  shopify_product_id: string;
  status: SyncStatus;
  vehicle_count: number;
  error?: string;
}

export interface SyncSummary {
  total: number;
  written: number;
  unchanged: number;
  skipped: number;
  errors: number;
}

export interface SyncResponse {
  summary: SyncSummary;
  results: SyncResult[];
}

export async function syncShopifyFitment(
  scope: 'all' | { ids: number[] },
  opts: { force?: boolean } = {},
): Promise<SyncResponse> {
  const body =
    scope === 'all'
      ? { scope: 'all', force: opts.force }
      : { scope: 'wheels', ids: scope.ids, force: opts.force };
  return apiFetch<SyncResponse>('/internal/sync-shopify-fitment', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
